import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../core/services/api.service';

export interface BsIncoterm {
  incotermId: number;
  name: string;
}

export interface BsIntegrator {
  integratorId: number;
  name: string;
}

export interface BsInverterModel {
  inverterModelId: number;
  name: string;
  description?: string;
}

export interface BsProjectStatus {
  projectStatusId: number;
  name: string;
}

export interface BsTransformer {
  transformerId: number;
  name: string;
  description?: string;
}

@Injectable({ providedIn: 'root' })
export class BlockScheduleAdminService {

  constructor(private apiService: ApiService) {}

  // ─── Incoterm ───────────────────────────────────────────────────────────────

  getIncoterms(): Observable<BsIncoterm[]> {
    return this.apiService.get('BlockScheduleAdmin/incoterms');
  }

  saveIncoterm(item: BsIncoterm): Observable<boolean> {
    return this.apiService.post('BlockScheduleAdmin/incoterms', item);
  }

  deleteIncoterm(id: number): Observable<boolean> {
    return this.apiService.delete(`BlockScheduleAdmin/incoterms/${id}`);
  }

  // ─── Integrator ─────────────────────────────────────────────────────────────

  getIntegrators(): Observable<BsIntegrator[]> {
    return this.apiService.get('BlockScheduleAdmin/integrators');
  }

  saveIntegrator(item: BsIntegrator): Observable<boolean> {
    return this.apiService.post('BlockScheduleAdmin/integrators', item);
  }

  deleteIntegrator(id: number): Observable<boolean> {
    return this.apiService.delete(`BlockScheduleAdmin/integrators/${id}`);
  }

  // ─── InverterModel ──────────────────────────────────────────────────────────

  getInverterModels(): Observable<BsInverterModel[]> {
    return this.apiService.get('BlockScheduleAdmin/inverter-models');
  }

  saveInverterModel(item: BsInverterModel): Observable<boolean> {
    return this.apiService.post('BlockScheduleAdmin/inverter-models', item);
  }

  deleteInverterModel(id: number): Observable<boolean> {
    return this.apiService.delete(`BlockScheduleAdmin/inverter-models/${id}`);
  }

  // ─── ProjectStatus ──────────────────────────────────────────────────────────

  getProjectStatuses(): Observable<BsProjectStatus[]> {
    return this.apiService.get('BlockScheduleAdmin/project-statuses');
  }

  saveProjectStatus(item: BsProjectStatus): Observable<boolean> {
    return this.apiService.post('BlockScheduleAdmin/project-statuses', item);
  }

  deleteProjectStatus(id: number): Observable<boolean> {
    return this.apiService.delete(`BlockScheduleAdmin/project-statuses/${id}`);
  }

  // ─── Transformer ────────────────────────────────────────────────────────────

  getTransformers(): Observable<BsTransformer[]> {
    return this.apiService.get('BlockScheduleAdmin/transformers');
  }

  saveTransformer(item: BsTransformer): Observable<boolean> {
    return this.apiService.post('BlockScheduleAdmin/transformers', item);
  }

  deleteTransformer(id: number): Observable<boolean> {
    return this.apiService.delete(`BlockScheduleAdmin/transformers/${id}`);
  }
}
